/**
 * @generated SignedSource<<dbc0dd2c31584cd1344438f05c815447>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type salesChannelSwitchQueriesCustomPlanOutcomeQuery$variables = {
  id: string;
};
export type salesChannelSwitchQueriesCustomPlanOutcomeQuery$data = {
  readonly productSwitcherTask: {
    readonly extraData: {
      readonly customPlan: {
        readonly financialPreview: {
          readonly currentPlan: {
            readonly billingCyclePrice: number;
            readonly billingPeriod: number;
            readonly billingPeriodUnit: string;
            readonly currencyCode: string;
          };
          readonly isEstimate: boolean;
          readonly newPlan: {
            readonly billingCyclePrice: number;
            readonly billingPeriod: number;
            readonly billingPeriodUnit: string;
            readonly currencyCode: string;
          };
          readonly paymentOnPlanChange: {
            readonly currencyCode: string;
            readonly estimatedCreditApplied: number;
            readonly estimatedRefundValue: number;
            readonly nextRenewalAmount: number;
            readonly nextRenewalAtUtc: string | null;
          };
          readonly proration: {
            readonly available: boolean;
            readonly remainingDays: number;
          };
          readonly warnings: ReadonlyArray<string>;
        };
        readonly planID: number;
      } | null;
      readonly reusedPlanID: number | null;
    };
    readonly id: string;
  } | null;
};
export type salesChannelSwitchQueriesCustomPlanOutcomeQuery = {
  response: salesChannelSwitchQueriesCustomPlanOutcomeQuery$data;
  variables: salesChannelSwitchQueriesCustomPlanOutcomeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currencyCode",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "billingCyclePrice",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "billingPeriod",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "billingPeriodUnit",
    "storageKey": null
  },
  (v1/*:: as any*/)
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ProductSwitcherTask",
    "kind": "LinkedField",
    "name": "productSwitcherTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductSwitcherTaskExtraData",
        "kind": "LinkedField",
        "name": "extraData",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reusedPlanID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CreateCustomPlanForSellerResponse",
            "kind": "LinkedField",
            "name": "customPlan",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "planID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CustomPlanChangePreview",
                "kind": "LinkedField",
                "name": "financialPreview",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isEstimate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomPlanPricePreview",
                    "kind": "LinkedField",
                    "name": "currentPlan",
                    "plural": false,
                    "selections": (v2/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomPlanPricePreview",
                    "kind": "LinkedField",
                    "name": "newPlan",
                    "plural": false,
                    "selections": (v2/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomPlanProrationPreview",
                    "kind": "LinkedField",
                    "name": "proration",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "available",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "remainingDays",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomPlanPaymentPreview",
                    "kind": "LinkedField",
                    "name": "paymentOnPlanChange",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "estimatedCreditApplied",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "estimatedRefundValue",
                        "storageKey": null
                      },
                      (v1/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "nextRenewalAtUtc",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "nextRenewalAmount",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "warnings",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelSwitchQueriesCustomPlanOutcomeQuery",
    "selections": (v3/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "salesChannelSwitchQueriesCustomPlanOutcomeQuery",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "cacheID": "8c79c441edeeaf81f4ab08a0a8a08b80",
    "id": null,
    "metadata": {},
    "name": "salesChannelSwitchQueriesCustomPlanOutcomeQuery",
    "operationKind": "query",
    "text": "query salesChannelSwitchQueriesCustomPlanOutcomeQuery(\n  $id: ID!\n) {\n  productSwitcherTask(id: $id) {\n    id\n    extraData {\n      reusedPlanID\n      customPlan {\n        planID\n        financialPreview {\n          isEstimate\n          currentPlan {\n            billingCyclePrice\n            billingPeriod\n            billingPeriodUnit\n            currencyCode\n          }\n          newPlan {\n            billingCyclePrice\n            billingPeriod\n            billingPeriodUnit\n            currencyCode\n          }\n          proration {\n            available\n            remainingDays\n          }\n          paymentOnPlanChange {\n            estimatedCreditApplied\n            estimatedRefundValue\n            currencyCode\n            nextRenewalAtUtc\n            nextRenewalAmount\n          }\n          warnings\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "65902192c6d44eaabdf2cb32dbecd03b";

export default node;
